"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Accordion_1 = __importDefault(require("@material-ui/core/Accordion"));
const AccordionDetails_1 = __importDefault(require("@material-ui/core/AccordionDetails"));
const AccordionSummary_1 = __importDefault(require("@material-ui/core/AccordionSummary"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const react_1 = __importStar(require("react"));
const lib_1 = require("../../../lib");
const ConfirmationModal_1 = __importDefault(require("../../Modals/ConfirmationModal"));
const placeholders_1 = require("../../placeholders");
const Table_1 = __importDefault(require("../../Table"));
const defaultActions_1 = __importDefault(require("../../Table/defaultActions"));
const context_1 = __importDefault(require("../context"));
const domain_1 = require("../domain");
const styles_1 = __importDefault(require("../styles"));
const InputList = ({ name, label, newLabel = `Add new ${name}`, editLabel = ({ id }) => `Edit '${id}'`, deleteLabel = ({ id }) => `Delete '${id}'`, deleteMessage = () => '', fields, accordionProps = {}, InputModal, }) => {
    const { obj, updatePropertyF } = react_1.useContext(context_1.default);
    const classes = styles_1.default();
    const { isOpen: isAddModalOpen, open: openAddModal, close: closeAddModal, } = lib_1.useModal();
    const { isOpen: isEditModalOpen, data: editModalData = {}, open: openEditModal, close: closeEditModal, } = lib_1.useModal();
    const { isOpen: isDeleteModalOpen, data: deleteModalData = {}, open: openDeleteModal, close: closeDeleteModal, } = lib_1.useModal();
    const [createKey, incrementCreateKey] = lib_1.useIncrementalKey();
    const values = react_1.useMemo(() => lib_1.deepGet(obj, name, []), [obj, name]);
    const actions = react_1.useMemo(() => defaultActions_1.default({
        onEdit: openEditModal,
        onDelete: openDeleteModal,
    }), [openEditModal, openDeleteModal]);
    function isEqual(val1, val2) {
        return ((val1.id && val1.id === val2.id) ||
            (val1.syntheticId && val1.syntheticId === val2.syntheticId));
    }
    return (react_1.default.createElement(Accordion_1.default, Object.assign({ defaultExpanded: true }, accordionProps),
        react_1.default.createElement(AccordionSummary_1.default, { expandIcon: react_1.default.createElement(ExpandMore_1.default, null), "aria-controls": `${name}-content`, id: `${name}-header` },
            react_1.default.createElement(Typography_1.default, { className: classes.expansionPanelHeading }, label)),
        react_1.default.createElement(AccordionDetails_1.default, { className: classes.expansionPanelContent },
            react_1.default.createElement(Grid_1.default, { container: true, direction: "column" },
                react_1.default.createElement(Grid_1.default, { item: true, className: classes.expansionPanelTable }, values.length ? (react_1.default.createElement(Table_1.default
                // cast is safe because we checked it before
                , { 
                    // cast is safe because we checked it before
                    columns: fields.filter((field) => !domain_1.isHiddenField(field)), actions: actions, rows: values, onRowClick: openEditModal })) : (react_1.default.createElement(Typography_1.default, { key: name, className: classes.expansionPanelNoContent },
                    "No ",
                    label.toLowerCase(),
                    ". Please add some."))),
                react_1.default.createElement(Grid_1.default, { item: true, container: true, className: classes.expansionPanelButtonsWrapper },
                    react_1.default.createElement(placeholders_1.FlexExpander, null),
                    react_1.default.createElement(Button_1.default, { onClick: openAddModal }, "Add")))),
        react_1.default.createElement(InputModal, { title: newLabel, formKey: `${createKey}`, open: isAddModalOpen, fields: fields, onClose: closeAddModal, onCreate: (newValue) => {
                updatePropertyF(name, (oldValues = []) => [
                    ...oldValues,
                    Object.assign(Object.assign({}, newValue), { syntheticId: lib_1.uuid() }),
                ]);
                incrementCreateKey();
            } }),
        react_1.default.createElement(InputModal, { title: editLabel(editModalData), formKey: editModalData.id || editModalData.syntheticId, open: isEditModalOpen, fields: fields, defaultValue: editModalData, saveLabel: "Save", onClose: closeEditModal, onCreate: (newValue) => {
                updatePropertyF(name, (oldValues) => oldValues.map((value) => isEqual(value, newValue) ? newValue : value));
                closeEditModal();
            } }),
        react_1.default.createElement(ConfirmationModal_1.default, { title: deleteLabel(deleteModalData), message: deleteMessage(deleteModalData), open: isDeleteModalOpen, onCancel: closeDeleteModal, onAccept: () => {
                updatePropertyF(name, (oldValues) => oldValues.filter((value) => !isEqual(value, deleteModalData)));
                closeDeleteModal();
            } })));
};
exports.default = InputList;
//# sourceMappingURL=List.js.map